import React from "react";
import useJobWorkshopConfigData from "../../../hooks/useJobWorkshopConfigData";
import {getJobWorkshopConfigData} from "../../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import LoadingSpinner from "../../Utils/Spinner";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import JobWorkshopConfigRow from "./JobWorkshopConfigRow";
import {createSetJobWorkshopConfigData} from "../../../actions/dataActions";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";


export default function JobWorkshopConfig(){
    const dispatch = useDispatch();
    let loaded = useJobWorkshopConfigData({});
    let data = useSelector(getJobWorkshopConfigData);

    const onChange = (e, index) => {
        let newResults = [...data.results];
        let newData = {...data, results: newResults};
        let newConf = {...data.results[index], [e.target.name]: e.target.value};
        newData.results[index] = newConf;
        dispatch(createSetJobWorkshopConfigData(newData));
    }

    const onSave = (item, index) => {
        const conf = {
            method: "put",
            data: item,
            url: "api/workshopconfig/"+item.id
        }
        axios(conf).then(res =>{
            data.results[index] = res.data
            dispatch(createSetJobWorkshopConfigData(data.results));
        }).catch(err =>{
            toast.error("There was an error", {position: "top-right"});
        })
    }


    if(!loaded){
        return <LoadingSpinner/>
    }

    return (
        <div>
            <br/>
            <Box>
                <Title>Workshop Config</Title>
                    <Columns isMultiline>
                        <Column>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Reminder (days after book in date)</th>
                                        <th>Warning Days (days after book in date)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map( (item, index) => (
                                    <JobWorkshopConfigRow
                                        data={item}
                                        index={index}
                                        onChange={onChange}
                                        onSave={onSave}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
            </Box>
        </div>
    );


}